export type Platform = 'Mac OS' | 'iOS' | 'Windows' | 'Android' | 'Linux' | 'unknown'

export const Platforms = {
    macOS: 'Mac OS',
    iOS: 'iOS',
    windows: 'Windows',
    android: 'Android',
    linux: 'Linux',
    unknown: 'unknown',
} as const

export function getPlatform(navigatorUserAgent: string, navigatorPlatform: string): Platform {
    const macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K']
    const windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE']
    const iosPlatforms = ['iPhone', 'iPad', 'iPod']
    if (macosPlatforms.indexOf(navigatorPlatform) !== -1) {
        return Platforms.macOS
    }
    if (iosPlatforms.indexOf(navigatorPlatform) !== -1) {
        return Platforms.iOS
    }
    if (windowsPlatforms.indexOf(navigatorPlatform) !== -1) {
        return Platforms.windows
    }
    if (/Android/.test(navigatorUserAgent)) {
        return Platforms.android
    }
    if (/Linux/.test(navigatorPlatform)) {
        return Platforms.linux
    }
    return Platforms.unknown
}
